import { message } from 'antd';
import { PUSH_SETTLEMENT_USAGE_URL, PUSH_USAGE_URL } from '../utils/api-url';
import { isValidArray } from '../utils/utilities';
import { roundNumber } from '../utils/math.utils';
import { postCall } from '../utils/network.util';
import { getPartnerActivityTotals } from '../utils/ota-partner.util';

/*
  QwikBus program totals for billing SKUs: maven's legacy fields plus every
  other registered OTA partner's activity (workflow rows arrive unfolded).
*/
const getQwikbusProgramTotals = (element) => {
    const partnerTotals = getPartnerActivityTotals(element.partnerActivity);
    return {
        confirmedFare: (Number(element.mavenConfirmedFare) || 0) + partnerTotals.confirmedFare,
        cancellationPenality: (Number(element.mavenCancellationPenality) || 0) + partnerTotals.cancellationPenality
    };
};

export const pushUsage = (fromDate,toDate,workFlowSummary,onSuccess=()=>{},onFailure=()=>{}) => {
    let skuData=[];    
    workFlowSummary.forEach(element => {
        if(element.operatorCode != "SRMS" && element.operatorCode != "DEMO"){
            const programTotals = getQwikbusProgramTotals(element);
            skuData.push({
                operatorCode:element.operatorCode,
                items:[
                    {
                        sku:"SMS",
                        quantity:element.smsCount
                    },
                    {
                        sku:"STDTRP",
                        quantity:element.serviceCounts
                    },
                    {
                        sku:"SSTRP",
                        quantity:element.seatSharingServiceCount
                    },
                    {
                        sku:"WEBCH",
                        quantity:roundNumber(element.confirmedAmount + element.cancelledAmount)
                    },
                    {
                        sku:"QBUS",
                        quantity:roundNumber(programTotals.confirmedFare)
                    },
                    {
                        sku:"API",
                        quantity:roundNumber(programTotals.confirmedFare)
                    }
                ]
            });
        }

    });
    var created = postCall(PUSH_USAGE_URL, {  
        fromDate,
        toDate ,
        "skuData":skuData    
    });
          created.then((data) => {            
          if(data.status === "SUCCESS" && data.payload.Status === "SUCCESS"){
              onSuccess(data.payload.Message);
          }else{
            onFailure(data.payload.Message);
          }
        })
        .catch((reason)=> {
            console.log({reason});
            onFailure(`Push data failed`);
        })
  }

  export const pushSettlementUsage = (fromDate,toDate,workFlowSummary,onSuccess=()=>{},onFailure=()=>{}) => {
    let skuData=[];    
    workFlowSummary.forEach(element => {
        if(element.operatorCode != "SRMS" && element.operatorCode != "DEMO"){
            const programTotals = getQwikbusProgramTotals(element);
            skuData.push({
                operatorCode:element.operatorCode,
                confirmedTicketValue:roundNumber(element.confirmedAmount),
                cancellationPenalty:roundNumber(element.cancellationPenality),
                qwikbusBooking:roundNumber(programTotals.confirmedFare),
                qwikbusCancellationPenalty:roundNumber(programTotals.cancellationPenality)
            });
        }

    });
    var created = postCall(PUSH_SETTLEMENT_USAGE_URL, {  
        fromDate,
        toDate ,
        "skuData":skuData    
    });
          created.then((data) => {            
          if(data.status === "SUCCESS" && data.payload.Status === "SUCCESS"){
              onSuccess(data.payload.Message);
          }else{
            onFailure(data.payload.Message);
          }
        })
        .catch((reason)=> {
            console.log({reason});
            onFailure(`Push data failed`);
        })
  }